var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUncollect = function SvgUncollect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64216 9.53129L5.99994 8.29165L6.62038 8.61778L8.35811 9.53121L7.90811 6.90582L8.40994 6.4166L9.81546 5.04641L7.17931 4.66335L6.86907 4.03483L6.00021 2.27464L4.82056 4.66335L4.12711 4.76414L2.18518 5.04637L4.0927 6.90594L3.97413 7.59685L3.64216 9.53129ZM3.11534 11.3147C2.42867 11.676 1.97801 11.3487 2.10867 10.584L2.66001 7.37133L0.326008 5.096C-0.229992 4.554 -0.0573251 4.02467 0.710675 3.91333L3.93534 3.44467L5.37867 0.522C5.72201 -0.174 6.27867 -0.174 6.62201 0.522L8.06467 3.44467L11.29 3.91333C12.058 4.02467 12.23 4.554 11.6747 5.096L9.34067 7.37133L9.89134 10.584C10.022 11.3487 9.57267 11.676 8.88534 11.3147L6.00001 9.798L3.11534 11.3147Z",
    fill: "#71717A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUncollect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uncollect.af184736.svg";
export { ForwardRef as ReactComponent };